var dispatcher = require("../dispatcher");
var axios = require('axios');
var constants = require("../constants/constants");
var EventEmitter = require('events').EventEmitter;
var em = new EventEmitter();

function UsTodniKamgarStore() {
    var listener = [];
    var Employe = [];
    var Mukadam = {};
    var Kamgar = [];
    var MukadamRecord = [];
    var KamgarRecord = [];
    function getMukadamInfo() {
        return Mukadam;
    }

    function getKamgarInfo() {
        return Kamgar;
    }

    function getMukadamRecord() {
        return MukadamRecord;
    }

    function getKamgarRecord() {
        return KamgarRecord;
    }

    function addListener(eventName, callback) {
        em.addListener(eventName, callback);
    }

    function removeListener(eventName, callback) {
        em.removeListener(eventName, callback);
    }

    function onChange(listener) {
        listener.push(listener);
    }
    //Add ustodni kamgar
    function addKamgar(KamgarInfo) {
        //let CompanyId = localStorage.getItem('CompanyId') || 1;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.post(constants.config.HOST + constants.api.POST_IF_EXIST_KAMGAR_DETAILS, {
            AdharCardNo: KamgarInfo.AdharCardNo
        }).then(function (response) {
            getMukadamInfo = (response.data);
            em.emit('Mukadam');
            if (response.data.IsAllow === 'True') {
                // var headers = { 'Content-Type': 'multipart/form-data' }
                const bodyFormData = new FormData();
                bodyFormData.append('file', KamgarInfo.selectedUserPhoto);
                bodyFormData.append('MukadamId', KamgarInfo.MukadamName);
                bodyFormData.append('FirstName', KamgarInfo.fname);
                bodyFormData.append('MiddleName', KamgarInfo.mname);
                bodyFormData.append('LastName', KamgarInfo.lname);
                bodyFormData.append('Gender', KamgarInfo.gender);
                bodyFormData.append('Address', KamgarInfo.addr);
                bodyFormData.append('Distric', KamgarInfo.Distric);
                bodyFormData.append('Taluka', KamgarInfo.Taluka);
                bodyFormData.append('village', KamgarInfo.village);
                bodyFormData.append('State', KamgarInfo.States);
                bodyFormData.append('Pincode', KamgarInfo.pincode);
                bodyFormData.append('ContactNo', KamgarInfo.contact);
                bodyFormData.append('AlteNativecontact', KamgarInfo.AlteNativecontact = '0');
                bodyFormData.append('AdharCardNo', KamgarInfo.AdharCardNo);
                bodyFormData.append('CompanyId', KamgarInfo.CompanyId);
                bodyFormData.append('YearId', user.TargetYearId);
                bodyFormData.append('TransportersId', user.TransportersId);
                // bodyFormData.append('fileName', KamgarInfo.fileName);
                const config = {
                    header: { 'Content-Type': 'multipart / form - data' }
                }
                const url = constants.config.HOST + constants.api.POST_EMPLOYEE_INFO;
                axios.post(url, bodyFormData, config)
                    .then(function (response) {
                        console.log(response);
                        em.emit('Kamgar');
                    }).catch(function (error) {
                        console.log(error);
                    });
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    //Add Mukadam  information
    function addMukadam(KamgarInfo) {
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.post(constants.config.HOST + constants.api.POST_IF_EXIST_MUKADAM_DETAILS, {
            AdharCardNo: KamgarInfo.AdharCardNo
        }).then(function (response) {
            getMukadamInfo = (response.data);
            em.emit('Mukadam');
            if (response.data.IsAllow === 'True') {
                //   var headers = { 'Content-Type': 'multipart/form-data' }
                const bodyFormData = new FormData();
                bodyFormData.append('file', KamgarInfo.selectedUserPhoto);
                bodyFormData.append('FirstName', KamgarInfo.fname);
                bodyFormData.append('MiddleName', KamgarInfo.mname);
                bodyFormData.append('LastName', KamgarInfo.lname);
                bodyFormData.append('Gender', KamgarInfo.gender);
                bodyFormData.append('Address', KamgarInfo.addr);
                bodyFormData.append('Distric', KamgarInfo.Distric);
                bodyFormData.append('Taluka', KamgarInfo.Taluka);
                bodyFormData.append('village', KamgarInfo.village);
                bodyFormData.append('State', KamgarInfo.States);
                bodyFormData.append('Pincode', KamgarInfo.pincode);
                bodyFormData.append('ContactNo', KamgarInfo.contact);
                bodyFormData.append('AlteNativecontact', KamgarInfo.AlteNativecontact = '0');
                bodyFormData.append('AdharCardNo', KamgarInfo.AdharCardNo);
                bodyFormData.append('CompanyId', KamgarInfo.CompanyId);
                bodyFormData.append('YearId', user.TargetYearId);
                bodyFormData.append('TransportersId', user.TransportersId);
                const config = {
                    header: { 'Content-Type': 'multipart / form - data' }
                }
                const url = constants.config.HOST + constants.api.POST_MUKADAM_INFO;
                axios.post(url, bodyFormData, config)
                    .then(function (response) {
                        console.log(response);
                        // Mukadam=(response.data)
                        em.emit('Mukadam');
                    }).catch(function (error) {
                        console.log(error);
                    });
            }




        }).catch(function (error) {
            console.log(error);
        });
    }

    //UpdateMukadam
    function UpdateMukadam(KamgarInfo) {
        var user = JSON.parse(sessionStorage.getItem("User"));
        // var headers = { 'Content-Type': 'multipart/form-data' }
        const bodyFormData = new FormData();
        bodyFormData.append('userPhoto', KamgarInfo.userPhoto);
        bodyFormData.append('MukadamId', KamgarInfo.MukadamId);
        bodyFormData.append('FirstName', KamgarInfo.fname);
        bodyFormData.append('MiddleName', KamgarInfo.mname);
        bodyFormData.append('LastName', KamgarInfo.lname);
        bodyFormData.append('Gender', KamgarInfo.gender);
        bodyFormData.append('Address', KamgarInfo.addr);
        bodyFormData.append('Distric', KamgarInfo.Distric);
        bodyFormData.append('Taluka', KamgarInfo.Taluka);
        bodyFormData.append('village', KamgarInfo.village);
        bodyFormData.append('State', KamgarInfo.States);
        bodyFormData.append('Pincode', KamgarInfo.pincode);
        bodyFormData.append('ContactNo', KamgarInfo.contact);
        bodyFormData.append('AlteNativecontact', KamgarInfo.AlteNativecontact = '0');
        bodyFormData.append('AdharCardNo', KamgarInfo.AdharCardNo);
        bodyFormData.append('CompanyId', KamgarInfo.CompanyId);
        bodyFormData.append('YearId', user.TargetYearId);
        bodyFormData.append('TransportersId', user.TransportersId);
        const config = {
            header: { 'Content-Type': 'multipart / form - data' }
        }
        const url = constants.config.HOST + constants.api.PUT_MUKADAM_INFO;
        axios.put(url, bodyFormData, config)
            .then(function (response) {
            }).catch(function (error) {
                console.log(error);
            });
    }

    //UpdateWorker
    function UpdateKamgar(KamgarInfo) {
        var user = JSON.parse(sessionStorage.getItem("User"));
        const bodyFormData = new FormData();
        bodyFormData.append('userPhoto', KamgarInfo.userPhoto);
        bodyFormData.append('MukadamId', KamgarInfo.MukadamName);
        bodyFormData.append('WorkarId', KamgarInfo.WorkarId);
        bodyFormData.append('FirstName', KamgarInfo.fname);
        bodyFormData.append('MiddleName', KamgarInfo.mname);
        bodyFormData.append('LastName', KamgarInfo.lname);
        bodyFormData.append('Gender', KamgarInfo.gender);
        bodyFormData.append('Address', KamgarInfo.addr);
        bodyFormData.append('Distric', KamgarInfo.Distric);
        bodyFormData.append('Taluka', KamgarInfo.Taluka);
        bodyFormData.append('village', KamgarInfo.village);
        bodyFormData.append('State', KamgarInfo.States);
        bodyFormData.append('Pincode', KamgarInfo.pincode);
        bodyFormData.append('ContactNo', KamgarInfo.contact);
        bodyFormData.append('AlteNativecontact', KamgarInfo.AlteNativecontact = '0');
        bodyFormData.append('AdharCardNo', KamgarInfo.AdharCardNo);
        bodyFormData.append('CompanyId', KamgarInfo.CompanyId);
        bodyFormData.append('YearId', user.TargetYearId);
        bodyFormData.append('TransportersId', user.TransportersId);
        const config = {
            header: { 'Content-Type': 'multipart / form - data' }
        }
        const url = constants.config.HOST + constants.api.PUT_EMPLOYEE_INFO;
        axios.put(url, bodyFormData, config)
            .then(function (response) {
            }).catch(function (error) {
                console.log(error);
            });
    }

    function BlackListMukadam(Mukadam) {
        axios.put(constants.config.HOST + constants.api.PUT_MUKADAM_BLACKLIST, {
            MukadamId: Mukadam.MukadamId.MukadamId,
            CompanyId: Mukadam.MukadamId.CompanyId,
            Note: Mukadam.note
        }).then(function (response) {
            em.emit('MukadamRecord');
        }).catch(function (error) {
            console.log(error);
        })
    }

    function BlackListKamgar(Workar) {
        axios.put(constants.config.HOST + constants.api.PUT_KAMGAR_BLACKLIST, {
            WorkarId: Workar.WorkarId.WorkarId,
            CompanyId: Workar.WorkarId.CompanyId,
            Note: Workar.note
        }).then(function (response) {
           
            em.emit('KamgarRecord');
        }).catch(function (error) {
            console.log(error);
        })
    }

    dispatcher.register(function (payload) {
        var split = payload.type.split(":");
        if (split[0] === "KamgarInfo") {
            switch (split[1]) {
                case "addKamgar": addKamgar(payload.KamgarInfo);
                    break;
                case "UpdateKamgar": UpdateKamgar(payload.KamgarInfo);
                    break;
                case "addMukadam": addMukadam(payload.KamgarInfo);
                    break;
                case "UpdateMukadam": UpdateMukadam(payload.KamgarInfo);
                    break;
                case "BlackListMukadam": BlackListMukadam(payload.Mukadam);
                    break;
                case "BlackListKamgar": BlackListKamgar(payload.Workar);
                    break;
            }
        }
    });
    return {
        onChange: onChange,
        addListener: addListener,
        removeListener: removeListener,
        getMukadamInfo: getMukadamInfo,
        getKamgarInfo: getKamgarInfo,
        getMukadamRecord: getMukadamRecord,
        getKamgarRecord: getKamgarRecord,
    }
}

module.exports = UsTodniKamgarStore();


// WEBPACK FOOTER //
// ./src/stores/UsTodniKamgarStore.js